import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../helpers/reducerRegistry'

const initialState = {} // { chartId1: {}, chartId2, {} }

export const slice = createSlice({
  name: 'common/charts',
  initialState,
  reducers: {
    setChartData: (state, action) => {
      const { chartId, ...rest } = action.payload
      if (!state[chartId]) state[chartId] = { chartId }
      state[chartId] = { ...state[chartId], ...rest }
    },
    deleteChartData: (state, action) => {
      const { chartId } = action.payload
      delete state[chartId]
    },
  },
})

export const selectChartData = (chartId, callback) => (state) => {
  const data = state[slice.name][chartId] || {}
  return callback ? callback(data) : data
}

export const { setChartData, deleteChartData } = slice.actions

register(slice.name, slice.reducer)
